import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [activeSlug, setActiveSlug] = useState(slug || 'qinggan-gushi');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const categoryArticles = articles.filter((a) => a.categorySlug === activeSlug);

  const handleCategoryChange = (newSlug: string) => {
    setActiveSlug(newSlug);
    navigate(`/category/${newSlug}`);
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: `${typeof window !== 'undefined' ? window.location.origin : ''}/` },
              { '@type': 'ListItem', position: 2, name: currentCategory?.name || '分类', item: typeof window !== 'undefined' ? window.location.href : '' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${currentCategory?.name || '分类'} - 朋友的姐姐`,
            description: currentCategory?.description || '探索青春情感故事',
            url: typeof window !== 'undefined' ? window.location.href : '',
            isPartOf: {
              '@type': 'WebSite',
              name: '朋友的姐姐',
              url: typeof window !== 'undefined' ? window.location.origin : '',
            },
          }),
        }}
      />

      <div className="pt-20 min-h-screen bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          {/* Breadcrumb */}
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: currentCategory?.name || '分类' },
            ]}
          />

          {/* Category Header */}
          <div className="mt-6 mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900">
              {currentCategory?.name}
            </h1>
            <p className="mt-2 text-foreground-600 text-sm md:text-base">
              {currentCategory?.description}
            </p>
          </div>

          {/* Category Tabs */}
          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryChange(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {/* Article Count */}
          <p className="text-sm text-foreground-500 mb-6">
            共 {categoryArticles.length} 篇文章
          </p>

          {/* Article List */}
          <div className="space-y-5">
            {categoryArticles.map((article) => (
              <ArticleCard key={article.id} article={article} variant="default" />
            ))}
          </div>

          {categoryArticles.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-4xl text-foreground-400 mb-4 block"></i>
              <p className="text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}